/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 119b712454200e9d6d738c0e8d2b04f064362ab76b9bd2008bf714441908f7f4
 */
import {
  tag_colorTagBlueBackground,
  tag_colorTagBlueBackgroundHover,
  tag_colorTagBlueText,
  tag_colorTagBlueTextHover,
  tag_colorTagDefaultBackground,
  tag_colorTagDefaultBackgroundHover,
  tag_colorTagHighlightBackground,
  tag_colorTagHighlightBackgroundHover,
  tag_colorTagHighlightText,
  tag_colorTagHighlightTextHover,
  tag_colorTagNewBackground,
  tag_colorTagNewBackgroundHover,
  tag_colorTagNewText,
  tag_colorTagNewTextHover,
  tag_colorTagPendingBackground,
  tag_colorTagPendingBackgroundHover,
  tag_colorTagPendingText,
  tag_colorTagPendingTextHover,
  tag_colorTagSevereBackground,
  tag_colorTagSevereBackgroundHover,
  tag_colorTagSevereText,
  tag_colorTagSevereTextHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import {
  cornerRadius,
  spacing,
} from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_size_lg,
  font_size_md,
  font_size_sm,
  font_size_xl,
  font_size_xs,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  align-items: center;
  border-radius: ${cornerRadius};
  border-style: solid;
  display: inline-flex;
  font-family: ${font_family_weight_regular};
  font-family: ${font_family_weight_regular};
  gap: ${spacing(1)};
  justify-content: center;
  white-space: nowrap;

  &.clickable {
    appearance: none;
    cursor: pointer;
  }

  &.clickable:disabled {
    cursor: not-allowed;
  }

  .leadingIcon,
  .trailingIcon {
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
  }

  .leadingIcon {
    justify-content: center;
  }

  &:not(.size-small) .leadingIcon,
  &:not(.size-small) .trailingIcon {
    height: ${font_size_md};
    width: ${font_size_md};
  }

  .leadingIcon > *,
  .trailingIcon > * {
    max-height: 100%;
    max-width: 100%;
  }

  &.size-small .leadingIcon,
  &.size-small .trailingIcon {
    display: none;
  }

  &.presentation-callout {
    border-width: 1px;
    font-size: ${font_size_md};
    height: ${spacing(7)};
    line-height: ${font_size_xl};
    padding-block: ${spacing(1)};
    padding-inline: ${spacing(2)};
  }

  &.presentation-default {
    border-width: ${spacing(0)};
    font-size: ${font_size_sm};
    height: ${spacing(5)};
    line-height: ${font_size_lg};
    padding-block: ${spacing(0)};
    padding-inline: ${spacing(2)};
  }

  &.presentation-inline-status {
    border-radius: ${spacing(0)};
    border-width: ${spacing(0)};
    font-size: ${font_size_sm};
    gap: ${spacing(2)};
    height: ${spacing(5)};
    line-height: ${font_size_lg};
    padding-block: ${spacing(0)};
    padding-inline: ${spacing(0)};
  }

  &.tone-ai {
    background: ${tag_colorTagNewBackground};
    color: ${tag_colorTagNewTextHover};
  }

  &.tone-ai.clickable:hover:not(:disabled) {
    background: ${tag_colorTagNewBackgroundHover};
    color: ${tag_colorTagNewTextHover};
  }

  &.tone-cool {
    background: ${tag_colorTagBlueBackground};
    color: ${tag_colorTagBlueTextHover};
  }

  &.tone-cool.clickable:hover:not(:disabled) {
    background: ${tag_colorTagBlueBackgroundHover};
    color: ${tag_colorTagBlueTextHover};
  }

  &.tone-highlight {
    background: ${tag_colorTagHighlightBackground};
    color: ${tag_colorTagHighlightTextHover};
  }

  &.tone-highlight.clickable:hover:not(:disabled) {
    background: ${tag_colorTagHighlightBackgroundHover};
    color: ${tag_colorTagHighlightTextHover};
  }

  &.tone-muted {
    background: ${tag_colorTagDefaultBackground};
    color: ${text_colorTextPrimary};
  }

  &.tone-muted.clickable:hover:not(:disabled) {
    background: ${tag_colorTagDefaultBackgroundHover};
    color: ${text_colorTextPrimary};
  }

  &.tone-severe {
    background: ${tag_colorTagSevereBackground};
    color: ${tag_colorTagSevereTextHover};
  }

  &.tone-severe.clickable:hover:not(:disabled) {
    background: ${tag_colorTagSevereBackgroundHover};
    color: ${text_colorTextPrimary};
  }

  &.tone-warning {
    background: ${tag_colorTagPendingBackground};
    color: ${tag_colorTagPendingTextHover};
  }

  &.tone-warning.clickable:hover:not(:disabled) {
    background: ${tag_colorTagPendingBackgroundHover};
    color: ${tag_colorTagPendingTextHover};
  }

  &.presentation-callout.tone-muted {
    border-color: ${text_colorTextSecondary};
  }

  &.presentation-callout.tone-muted.clickable:hover:not(:disabled) {
    border-color: ${text_colorTextPrimary};
  }

  &.presentation-callout.tone-severe {
    border-color: ${tag_colorTagSevereText};
  }

  &.presentation-callout.tone-severe.clickable:hover:not(:disabled) {
    border-color: ${text_colorTextPrimary};
  }

  &.presentation-callout.tone-highlight {
    border-color: ${tag_colorTagHighlightText};
  }

  &.presentation-callout.tone-highlight.clickable:hover:not(:disabled) {
    border-color: ${tag_colorTagHighlightTextHover};
  }

  &.presentation-callout.tone-cool {
    border-color: ${tag_colorTagBlueText};
  }

  &.presentation-callout.tone-cool.clickable:hover:not(:disabled) {
    border-color: ${tag_colorTagBlueTextHover};
  }

  &.presentation-callout.tone-ai {
    border-color: ${tag_colorTagNewText};
  }

  &.presentation-callout.tone-ai.clickable:hover:not(:disabled) {
    border-color: ${tag_colorTagNewTextHover};
  }

  &.presentation-callout.tone-warning {
    border-color: ${tag_colorTagPendingText};
  }

  &.presentation-callout.tone-warning.clickable:hover:not(:disabled) {
    border-color: ${tag_colorTagPendingTextHover};
  }

  &.presentation-inline-status.tone-muted {
    background: transparent;
    color: ${text_colorTextSecondary};
  }

  &.presentation-default.size-small {
    font-size: ${font_size_xs};
    height: auto;
    line-height: ${font_size_md};
    padding-block: ${spacing(0)};
    padding-inline: ${spacing(1)};
  }
`
